export default __webpack_public_path__ + "static/ASLA_Helio_1-e99d6f2469ef2e546f4a7c7569fa24fd.png";